// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiple-selector__title {
  font-family: "Public Sans";
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/form/AsyncSelector/AsyncSelector.scss"],"names":[],"mappings":"AAEE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AADJ","sourcesContent":[".multiple-selector {\n  \n  &__title {\n    font-family: \"Public Sans\";\n    font-size: 20px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 24px;\n    margin-bottom: 10px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
